import CookieBanner from './cookie_banner';

export default CookieBanner;
